import dayjs from "dayjs";

import { StoredPhotoMeta } from "@/Services/PhotoStorage";

export const getRetryDelayMs = (uploadAttempts: number) => {
    const nextAttempt = uploadAttempts + 1;
    if (nextAttempt <= 1) return 0;
    if (nextAttempt === 2) return 10 * 60 * 1000;
    if (nextAttempt === 3) return 30 * 60 * 1000;
    return 60 * 60 * 1000;
};

export const isNeedRetry = (p: StoredPhotoMeta) => {
    return !p.uploaded && !p.skipUpload;
};

export const isRetryReadyNow = (p: StoredPhotoMeta, now = dayjs()) => {
    if (!isNeedRetry(p)) return false;
    if (!p.lastUploadAt) return true;

    const delayMs = getRetryDelayMs(p.uploadAttempts);
    const nextAllowedAt = dayjs(p.lastUploadAt).add(delayMs, "millisecond");
    return now.isAfter(nextAllowedAt) || now.isSame(nextAllowedAt);
};
